import { render } from "./HeaderGestion.vue?vue&type=template&id=db70b890&scoped=true"
import script from "./HeaderGestion.vue?vue&type=script&lang=js"
export * from "./HeaderGestion.vue?vue&type=script&lang=js"

import "./HeaderGestion.vue?vue&type=style&index=0&id=db70b890&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db70b890"

export default script